export default __webpack_public_path__ + "static/media/left_top_new.70eae6d2.png";